const getters = {
  token: state => state.user.token,
  user: state => state.user.user,
}
export default getters
